import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css' // Your custom styles
import 'bootstrap/dist/css/bootstrap.min.css' // Bootstrap
import App from './App'
import reportWebVitals from './reportWebVitals'
import './i18n' // Ensure i18n is initialized here

// Root render
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Performance monitoring
reportWebVitals()
